<script setup lang="ts">
  const job = jobRepository.use();
</script>

<template>
  <WebView
    v-if="job?.isDesigned"
    class="designed"
    :html="job.html"
  />
</template>
